import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

import {
  COMMISSIONING_TABS,
  GATEWAY_COMMISSIONING_DEVICE,
  GATEWAY_COMMISSIONING_STEP,
  GatewayCommissioningStore,
} from '@store';

@Component({
  selector: 'app-commissioning-steps',
  templateUrl: './commissioning-steps.component.html',
  styleUrls: ['./commissioning-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningStepsComponent {
  readonly step = GATEWAY_COMMISSIONING_STEP;
  readonly currentStep = COMMISSIONING_TABS.CONNECT;
  readonly deviceType = GATEWAY_COMMISSIONING_DEVICE;

  @Input() activeStep: GATEWAY_COMMISSIONING_STEP;

  constructor(public gatewayCommissioningStore: GatewayCommissioningStore) {}

  nextStep(stepper: MatStepper): void {
    stepper.selected.completed = true;
    stepper.next();
  }

  previousStep(stepper: MatStepper): void {
    stepper.selected.completed = false;
    stepper.previous();
  }

  initialStep(stepper: MatStepper): void {
    stepper.reset();
  }
}
